import { render, staticRenderFns } from "./ReservesMainMenu.vue?vue&type=template&id=abdb19ae"
import script from "./ReservesMainMenu.vue?vue&type=script&lang=ts"
export * from "./ReservesMainMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports